import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { LoadStatusValue } from "@/components/orders/orderFormTypes";
import { LOAD_STATUS_OPTIONS } from "@/components/orders/form/advancedFields";

/**
 * Per-leg equipment state: load status (`legs.is_loaded`) plus temperature
 * control (`legs.is_temperature_controlled` / `legs.temperature_f`).
 */
export function EquipmentAdvancedFields({
  idPrefix,
  loadStatus,
  isTemperatureControlled,
  temperatureF,
  onLoadStatusChange,
  onTemperatureControlledChange,
  onTemperatureChange,
  disabled,
  required = true,
}: {
  idPrefix: string;
  loadStatus: LoadStatusValue;
  isTemperatureControlled: boolean;
  temperatureF: string;
  onLoadStatusChange: (v: LoadStatusValue) => void;
  onTemperatureControlledChange: (v: boolean) => void;
  onTemperatureChange: (v: string) => void;
  disabled?: boolean;
  required?: boolean;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <div>
        <Label>Load status{required ? " *" : ""}</Label>
        <Select
          value={loadStatus || undefined}
          onValueChange={(v) => onLoadStatusChange(v as LoadStatusValue)}
          disabled={disabled}
        >
          <SelectTrigger id={`${idPrefix}-load-status`}>
            <SelectValue placeholder="Select load status" />
          </SelectTrigger>
          <SelectContent>
            {LOAD_STATUS_OPTIONS.map((o) => (
              <SelectItem key={o.value} value={o.value}>
                {o.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-end pb-2">
        <label
          htmlFor={`${idPrefix}-temp-controlled`}
          className="flex cursor-pointer select-none items-center gap-2 text-sm font-medium"
        >
          <Checkbox
            id={`${idPrefix}-temp-controlled`}
            checked={isTemperatureControlled}
            onCheckedChange={(c) => onTemperatureControlledChange(c === true)}
            disabled={disabled}
          />
          Temperature controlled
        </label>
      </div>
      <div>
        <Label htmlFor={`${idPrefix}-temp`}>Temperature (°F)</Label>
        <Input
          id={`${idPrefix}-temp`}
          type="number"
          inputMode="decimal"
          value={temperatureF}
          onChange={(e) => onTemperatureChange(e.target.value)}
          placeholder="e.g., 34"
          disabled={disabled || !isTemperatureControlled}
        />
      </div>
    </div>
  );
}